<template>
  <div id="datatable" class="table_wrapper grey-back" :class="[propsObj.itemLabel && reportFilterObj && Object.keys(reportFilterObj).length ? 'four-lines-header' : !propsObj.itemLabel && (!reportFilterObj || (reportFilterObj && !Object.keys(reportFilterObj).length)) ? 'two-lines-header' : '']">

        <div class="reportdetails">
          <!-- <h3 class="body-2" v-if="$root.CurrentBusiness">{{$root.CurrentBusiness.BusinessName}}</h3> -->

          <p class="caption" v-if="propsObj.itemLabel" v-ripple @click="openDialogAndroid">
            <span class="font-medium">
              {{propsObj.itemLabel}}
            </span>: <span class="item-link">{{propsObj.itemName}}</span>
          </p>

          <p class="caption">

            <span @click="openDialogCustomDates" v-if="propsObj.periodLabel == 'Period'">
              <span class="font-medium">{{propsObj.periodLabel}}</span>: 
              <span class="item-link">{{propsObj.startDate | moment("DD-MMM-YYYY")}}</span> 
              <span class="item-link">To</span> 
              <span class="item-link">{{propsObj.endDate | moment("DD-MMM-YYYY")}}</span>
            </span>

            <span @click="openDatePicker('end', propsObj.endDate)" v-else>
              <span class="font-medium">{{propsObj.periodLabel}}</span>: 
              <span class="item-link">{{propsObj.endDate | moment("DD-MMM-YYYY")}}</span>
            </span>
            <!-- <span class="font-medium">{{propsObj.periodLabel}}</span>: 
            <span class="item-link" v-ripple @click="openDatePicker('start', propsObj.startDate)" v-if="propsObj.periodLabel=='Period'">{{propsObj.startDate | moment("DD-MMM-YYYY")}}</span>
            <span v-if="propsObj.periodLabel=='Period'">To</span>
            <span class="item-link" v-ripple @click="openDatePicker('end', propsObj.endDate)">{{propsObj.endDate | moment("DD-MMM-YYYY")}}</span> -->

            <v-menu style="position:absolute;right:16px" v-if="propsObj.periodLabel=='Period'">
                <v-btn justify-content-to-end style="height: 16px;" nomargin nopadding flat capitalize font-normal slot="activator">{{propsObj.selectedPeriod}}&nbsp;<v-icon font20>date_range</v-icon></v-btn>
                <v-list nopadding>
                  <v-list-tile v-for="(item, index) in periods" :key="index" @click="selectPeriod(item.value)">
                      <v-list-tile-title>{{item.title}}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
            </v-menu>

            <!-- <v-menu style="position:absolute;right:16px" v-if="$route.params.reportid == 109">
                <v-btn justify-content-to-end style="height: 16px;" nomargin nopadding flat capitalize font-normal slot="activator">{{propsObj.selectedPeriod ? propsObj.selectedPeriod : 'Custom'}}&nbsp;<v-icon font20>date_range</v-icon></v-btn>
                <v-list nopadding>
                  <v-list-tile v-for="(item, index) in periodsLastDays" :key="'period'+index" @click="selectDays(item)">
                      <v-list-tile-title>{{item.title}}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
            </v-menu> -->
          </p>

          <p class="caption" v-if="reportFilterObj && Object.keys(reportFilterObj).length">
            <span v-for="(filter, key, index) in reportFilterObj">
              <span class="font-medium">{{filter.name}}</span>: {{filter.value}}{{index!=Object.keys(reportFilterObj).length-1 ? ', ': ''}}
            </span>
          </p>
          
        </div>

        <v-divider></v-divider>

        <div class="tile-wrapper" style="padding-bottom:100px" v-if="propsObj.reportData && propsObj.reportData.detailRows">

          <div>
            <v-runtime-template :template="propsObj.tileContent"/>
          </div>
          
          <!-- <v-card v-for="(item, index) in propsObj.reportData.detailRows" :key="index">
            <v-card-text>

                <v-layout row wrap>
                  <v-flex xs10 sm10 md10 @click="fn_getDetails(item)">
                    <div v-for="(col, colIndex) in propsObj.tileViewColumns" :key="colIndex" v-if="item.cols[col.name]">
                      <div v-if="propsObj.reportData.headerRow[col.name] == 'Date'">
                        <span class="font-medium">{{col.header}}: </span>
                        <span v-if="item.cols[col.name]">{{item.cols[col.name] | moment("DD-MMM-YYYY")}}</span>
                        <span v-else>-</span>
                      </div>
                      <div v-else :class="{'font-medium':col.isBold}">
                        <span class="font-medium">{{col.header}}: </span>
                        {{item.cols[col.name] ? item.cols[col.name] : '-'}}
                      </div>
                    </div>
                  </v-flex>

                  <v-flex xs2 sm2 md2 right-align @click="fn_expandMore(item)">
                    <v-icon>more_horiz</v-icon>
                  </v-flex>
                </v-layout>

            </v-card-text>

            <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
          </v-card> -->

          <!-- <div class="endmsg">End of Report</div> -->

        </div>

        <div class="footer" style="padding-left:0 !important" id="tableFooter" v-if="propsObj.reportData.footerRow || propsObj.reportData.summaryRows" @click="$parent.$parent.tileViewTotalSheet = !$parent.$parent.tileViewTotalSheet">
          <v-runtime-template :template="propsObj.footerContent"/>
        </div>

        <!-- <div class="footer" style="padding-left:0 !important" id="tableFooter" v-if="propsObj.reportData.footerRow" @click="totalSheet = !totalSheet">
            <v-subheader subheader-dense dark-opacity-color>Total 
              <v-spacer></v-spacer>
              <v-icon>{{!totalSheet ? 'arrow_drop_up' : arrow_drop_down}}</v-icon>
            </v-subheader>
        </div> -->

        <v-bottom-sheet v-model="$parent.$parent.tileViewTotalSheet">
          <v-card class="report-details-card" v-if="$parent.$parent.tileViewTotalSheet">

            <v-subheader dark-opacity-color norightpadding>Total 
              <v-spacer></v-spacer>
              <v-btn icon flat @click="$parent.$parent.tileViewTotalSheet=false"><v-icon>close</v-icon></v-btn>
            </v-subheader>

            <v-divider></v-divider>

            <v-card-text>

              <v-layout row wrap>
                <v-flex xs6 sm6 md6>
                  <div style="padding:4px 0px;" v-for="(value, key) in propsObj.tileViewFooterHeaders">
                    <template v-if="$route.params.reportid==201">
                      {{ value == 'To Receive' ? $root.fn_getDebitLabel() : value == 'To Pay' ? $root.fn_getCreditLabel() : value }}
                    </template>
                    <template v-else>
                      {{ value ? value : '-' }}
                    </template>
                  </div>
                </v-flex>

                <v-flex xs6 sm6 md6 right-align>
                  <div style="padding:4px 0px;" v-if="$route.params.reportid==501 || $route.params.reportid==502"  v-for="(item, index) in propsObj.reportData.summaryRows" :key="index">
                    <strong>{{item.transactionListId ? $root.numberToLocale(item.transactionListId) : ''}}</strong>
                  </div>

                  <div style="padding:4px 0px;" v-if="$route.params.reportid!=501 && $route.params.reportid!=502" v-for="(value, key) in propsObj.tileViewFooterHeaders">
                    <!-- <strong>{{propsObj.reportData.footerRow[key] ? $root.numberToLocale(propsObj.reportData.footerRow[key]) : ''}}</strong> -->
                    <strong>
                        <span v-if="propsObj.reportData.footerRow[key] == null || propsObj.reportData.footerRow[key] == ''">-</span>
                        <span :class="{'redcolor':$route.params.reportid == 503 && propsObj.reportData.footerRow[key] && propsObj.reportData.footerRow[key] < 0}" v-else-if="key != 'dqty' && key != 'qty' && key != 'inward' && key!='actualInwardValue' && key != 'outward' && key!='actualOutwardValue' && key != 'voucherCount' && key != 'opening' && key != 'closing' && key != 'balance'">
                            {{$route.params.reportid == 503 ? $root.numberToLocale(Math.abs(propsObj.reportData.footerRow[key])) : $root.numberToLocale(propsObj.reportData.footerRow[key])}}
                        </span>
                        <span v-else>
                            <!-- {{$root.numberToLocale(propsObj.reportData.footerRow[key], 1)}} -->
                            {{propsObj.reportData.footerRow[key] ? propsObj.reportData.footerRow[key] : '-'}}
                        </span>
                    </strong>
                  </div>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-bottom-sheet>


        <v-bottom-sheet v-model="$parent.$parent.tileViewDetailSheet">

          <v-card class="report-details-card" v-if="$parent.$parent.tileViewDetailSheet && currentItem">
            <v-card-text>

              <v-layout row wrap>

                <template v-for="(col, colIndex) in propsObj.columns">
                  <v-flex class="pt-1 pb-1" xs4 sm4 md4 :key="'header'+colIndex">
                    <strong>{{propsObj.reportData.headerRow[colIndex].headerName ? propsObj.reportData.headerRow[colIndex].headerName : '-'}}</strong>
                  </v-flex>
                  
                  <v-flex class="pt-1 pb-1" xs8 sm8 md8 :key="'value'+colIndex">
                    <div right-align>
                      <span v-if="currentItem.cols[col]">
                        <span v-if="propsObj.reportData.headerRow[colIndex].type == 'date'">{{currentItem.cols[col] | moment("DD-MMM-YYYY")}}</span>
                        <span v-else-if="propsObj.reportData.headerRow[colIndex].type == 'number'">
                            <span v-if="col != 'dqty' && col != 'qty' && col != 'unit' && col != 'inward' && col!='actualInwardValue' && col != 'outward' && col!='actualOutwardValue' && col != 'voucherCount' && col != 'opening' && col != 'closing' && col != 'balance'">{{currentItem.cols[col] ? $root.numberToLocale(currentItem.cols[col]) : ''}}</span>
                            <!-- <span v-else>{{currentItem.cols[col] ? $root.numberToLocale(currentItem.cols[col], 1) : ''}}</span> -->
                            <span v-else>{{currentItem.cols[col] ? currentItem.cols[col] : ''}}</span>
                        </span>
                        <span v-else>{{currentItem.cols[col] ? currentItem.cols[col] : ''}}</span>
                      </span>
                      <span v-else>-</span>
                  </div>
                  </v-flex>

                </template>
                
                

              </v-layout>

              

              

            </v-card-text>
          </v-card>
        </v-bottom-sheet>

  </div>
</template>

<script>
const transactionForms = require('../../../config.js').configs.transactionForms;

import VRuntimeTemplate from "v-runtime-template";

  export default{
    props:['reportId', 'propsObj', 'openDialogAndroid', 'getReportItemDetails', 'openDatePicker', 'reportFilterObj', 'openTransaction', 'openAccountDetails', 'getSubReportData', 'periods', 'selectPeriod', 'openDialogCustomDates', 'periodsLastDays', 'selectDays'],
    data(){
      return{
        // totalSheet:false,
        // detailSheet:false,
        footerHeaders:null,
        currentItem:null
      }
    },
    components:{
      "v-runtime-template": VRuntimeTemplate
    },
    methods:{

      fn_expandMore: function(item){
        console.log(JSON.stringify(this.propsObj));
        this.currentItem = item;
        // this.detailSheet = true;
        this.$parent.$parent.tileViewDetailSheet = true;
      },

      fn_headerRowForFooter: function(){
        this.footerHeaders = {};
        let self = this;
        // for(let i in this.propsObj.reportData.headerRow){
        //   (function(headerKey){
        //     for(let j in self.propsObj.reportData.footerRow){
        //       if(self.propsObj.reportData.footerRow[j]){
        //         self.footerHeaders[j] = self.propsObj.reportData.headerRow[headerKey];
        //       }
        //     }
        //   }(i));
        // }
        for(let i=0; i<this.propsObj.reportData.headerRow.length; i++){
          (function(index){
            for(let j in self.propsObj.reportData.footerRow){
              if(self.propsObj.reportData.footerRow[j]){
                self.footerHeaders[j] = self.propsObj.reportData.headerRow[index].headerName;
              }
            }
          }(i));
        }
        // this.totalSheet = true;
        this.$parent.$parent.tileViewTotalSheet = true;
        console.log(JSON.stringify(this.footerHeaders));
      },

      fn_getTransactionType: function(listId){
        for(let i=0; i<transactionForms.length; i++){
          if(transactionForms[i].id==listId){
            return transactionForms[i].title;
          }
        }
      },

      fn_profitLossDetails: function(data){
        this.$parent.$parent.itemWiseProfitLossData = data.cols;
        setTimeout(() => {
          this.$parent.$parent.fn_openDialogWeb('web', 'ProfitLossDetails', 'ref_dialogProfitLossDetails');
        }, 100);
      },

      // fn_getDetails: function(item){
      //   if(this.$route.params.reportid == 201){
      //     this.getReportItemDetails(item.transactionListId, item.transactionId);
      //   }
      //   else if(this.propsObj.openView && item.transactionId && item.transactionListId){
      //     this.openTransaction(item.transactionListId, item.transactionId);
      //   }
      //   else if(item.accountId){
      //     this.$router.push({path:'/reports/'+this.$root.CurrentBusiness.BusinessID+'/'+201, query:{"itemId":item.accountId, "itemName":item.accountName}});
      //   }
      //   else if(item.productId){
      //     this.$router.push({path:'/reports/'+this.$root.CurrentBusiness.BusinessID+'/'+101, query:{"itemId":item.productId, "itemName":item.productName}});
      //   }
      // }

      fn_getDetails: function(item){

        let self = this;
        setTimeout(function(){
          self.propsObj.disableClick = false;
        },300);
        
        if(this.propsObj.disableClick){
          return;
        }

        this.propsObj.disableClick = true;
        let startDate = this.propsObj.startDate ? this.$moment(new Date(this.propsObj.startDate)).format('YYYY-MM-DD') : null;
        let endDate = this.$moment(new Date(this.propsObj.endDate)).format('YYYY-MM-DD');

        if(this.$route.params.reportid == 201){
          this.getReportItemDetails(item.transactionListId, item.transactionId);
        }
        else if(this.$route.params.reportid == 801 || this.$route.params.reportid == 802){
          this.getSubReportData(item.subReportId);
        }
        else if(this.$route.params.reportid == 803){
          this.getSubReportData(item);
        }
        else if(this.propsObj.openView && item.transactionId && item.transactionListId){
          this.openTransaction(item.transactionListId, item.transactionId);
        }
        // else if(this.propsObj.openAccount){
        //   this.openAccountDetails(item.accountId);
        // }
        else if(item.accountId){
          if(this.$route.params.reportid == 302 || this.$route.params.reportid == 402){
            let routeReportId = this.$route.params.reportid == 302 ? 301 : 401;
            // removing period from local storage before route update
            localStorage.removeItem('report_period_'+routeReportId);
            this.$router.push({path:'/reports/'+this.$root.CurrentBusiness.BusinessID+'/'+routeReportId, query:{"isFilter":true, "filterPartyId":item.accountId, "filterPartyName":item.accountName, "startDate":startDate, "endDate":endDate, "selectedPeriod":this.propsObj.selectedPeriod}});
          }
          else{
            // removing period from local storage before route update
            localStorage.removeItem('report_period_201');
            // this.$router.push({path:'/reports/'+this.$root.CurrentBusiness.BusinessID+'/'+201, query:{"itemId":item.accountId, "itemName":item.accountName, "startDate":startDate, "endDate":endDate, "selectedPeriod":this.propsObj.selectedPeriod}});

            if(this.$route.params.reportid == 413 || this.$route.params.reportid == 414){
              this.$router.push({path:'/reports/'+this.$root.CurrentBusiness.BusinessID+'/201', query:{"isFilter":true, "filtertypeFormName":"Expense", "itemId":item.accountId, "itemName":item.accountName, "startDate":startDate, "endDate":endDate, "selectedPeriod":this.propsObj.selectedPeriod}});
            }
            else if(this.$route.params.reportid == 504){
              this.$router.push({path:'/reports/'+this.$root.CurrentBusiness.BusinessID+'/'+505, query:{"itemId":item.accountId, "itemName":item.accountName, "startDate":startDate, "endDate":endDate, "selectedPeriod":this.propsObj.selectedPeriod}});
            }
            else if(this.$route.params.reportid == 605){
              this.$router.push({path:'/reports/'+this.$root.CurrentBusiness.BusinessID+'/'+604, query:{"itemId":item.accountId, "itemName":item.accountName, "startDate":startDate, "endDate":endDate, "selectedPeriod":this.propsObj.selectedPeriod}});
            }
            else{
              this.$router.push({path:'/reports/'+this.$root.CurrentBusiness.BusinessID+'/'+201, query:{"itemId":item.accountId, "itemName":item.accountName, "startDate":startDate, "endDate":endDate, "selectedPeriod":this.propsObj.selectedPeriod}});
            }
            
          }
        }
        else if(item.productId){
          // removing period from local storage before route update
          localStorage.removeItem('report_period_101');
          if(this.reportFilterObj.party){
            this.$router.push({path:'/reports/'+this.$root.CurrentBusiness.BusinessID+'/'+101, query:{"itemId":item.productId, "itemName":item.productName, "isFilter":true, "filterPartyId":this.reportFilterObj.party.id, "filterPartyName":this.reportFilterObj.party.value, "startDate":startDate, "endDate":endDate, "selectedPeriod":this.propsObj.selectedPeriod}});
          }
          else{
            if(this.$route.params.reportid == 410){
              this.$router.push('/masters/inventory/productandservices/items/'+item.productId);
            }
            else{
              if(this.$route.params.reportid == 105){
                this.$router.push({path:'/reports/'+this.$root.CurrentBusiness.BusinessID+'/'+106, query:{"itemId":item.productId, "itemName":item.productName, "startDate":startDate, "endDate":endDate, "selectedPeriod":this.propsObj.selectedPeriod, "itemId":item.cols.batchId, "itemName":item.cols.batchNumber ? item.productName + '/' + item.cols.batchNumber : item.productName}});  
              }
              else{
                this.$router.push({path:'/reports/'+this.$root.CurrentBusiness.BusinessID+'/'+101, query:{"itemId":item.productId, "itemName":item.productName, "startDate":startDate, "endDate":endDate, "selectedPeriod":this.propsObj.selectedPeriod}});  
              }
              // this.$router.push({path:'/reports/'+this.$root.CurrentBusiness.BusinessID+'/'+101, query:{"itemId":item.productId, "itemName":item.productName, "startDate":startDate, "endDate":endDate, "selectedPeriod":this.propsObj.selectedPeriod}});  
            }
          }
        }
        else if(this.$route.params.reportid == 412 && item.expenseCategoryId){
          this.$router.push('/masters/expensecategory/items/'+item.expenseCategoryId);
        }
        else if((this.$route.params.reportid == 413 || this.$route.params.reportid == 414) && !item.accountId){
          let filterType = this.$route.params.reportid == 413 ? 2 : 3;
          this.$router.push({path:'/transactions/purchase/expense/items', query:{"tagId":this.guidWeb(), filterType:filterType, "startDate":startDate, "endDate":endDate, "selectedPeriod":this.propsObj.selectedPeriod}});
        }
      },

    }
  }
</script>


// WEBPACK FOOTER //
// src/components/newreports/report_templates/tileview.vue